var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{staticClass:"text-area",attrs:{"rows":"3","solo":"","no-resize":"","hide-details":"","placeholder":_vm.placeholder,"readonly":_vm.readonly},model:{value:(_vm.localVal),callback:function ($$v) {_vm.localVal=$$v},expression:"localVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }